'use client';

import ProductImageGallery from '@/features/product/carousel/ProductImageGallery';

function normalizeHubProduct(game, fallbackImage = '') {
  const cover = Array.isArray(game?.coverImage)
    ? game.coverImage
    : [game?.coverImage];
  const extra = Array.isArray(game?.extraImages) ? game.extraImages : [];
  const imagesPaths = [...extra, fallbackImage]
    .map((image) => (typeof image === 'string' ? image.trim() : ''))
    .filter(Boolean);

  return {
    name: game?.name || game?.gameNumber || '',
    productNumber: game?.gameNumber || '',
    coverImage: cover,
    imagesPaths,
  };
}

export default function HubGameImageLightbox({
  game,
  fallbackImage = '',
  messages = {},
}) {
  return (
    <div className="hub-media-gallery">
      <ProductImageGallery
        product={normalizeHubProduct(game, fallbackImage)}
        messages={messages}
      />
    </div>
  );
}
